import { Select } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import React, { useState } from 'react'
import { CustomNumberInput } from '@/common/components/AntdForm/AntdFormNumberInput.tsx'
import { Currency } from '@/common/types/compensation.def.ts'

type Money = {
  currency?: string
  amount?: number
}

type MoneyInputProps = {
  value?: Money
  onChange?: (value: Money) => void
  currencyOptions: string[]
  disabled?: boolean
}

type AntdFormMoneyInputProps = {
  disabled?: boolean
  currencyOptions?: string[]
} & AntdFormItemProps

export const MoneyInput: React.FC<MoneyInputProps> = ({
  value = {},
  onChange,
  currencyOptions,
  disabled,
}) => {
  const [currency, setCurrency] = useState(currencyOptions[0])
  const [amount, setAmount] = useState(0)

  const triggerChange = (changedValue: Money) => {
    onChange?.({ ...value, ...changedValue })
  }

  const onFieldValueChange = (newVal: number | null) => {
    const newNumber = newVal || 0
    setAmount(newNumber)
    triggerChange({ currency, amount: newNumber })
  }

  const onCurrencyChange = (value: string) => {
    setCurrency(value)
    triggerChange({ currency: value, amount: amount })
  }

  const CurrencySelector = (
    <Select value={currency} onChange={onCurrencyChange} className="!w-32" disabled={disabled} showSearch>
      {currencyOptions.map(x => <Select.Option key={x} value={x}>{x}</Select.Option>)}
    </Select>
  )

  return (
    <CustomNumberInput
      size="middle"
      value={value.amount}
      onChange={val => onFieldValueChange(val as number)}
      addonBefore={CurrencySelector}
      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      disabled={disabled}
    />
  )
}

export const AntdFormMoneyInput: React.FC<AntdFormMoneyInputProps> = ({
  fieldProps,
  currencyOptions,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps}>
      <MoneyInput {...props} currencyOptions={currencyOptions ?? Object.values(Currency)} />
    </AntdFormItem>
  )
}
